module.exports = __webpack_public_path__ + "img/logo-woco-vanalckmaer-white.511bb1ef.png";